import { mapState } from "vuex";
export const invoicingIndexMixins = {
  computed: {
    invoicingTopBarList() {
        let topbarList = [
          {
            name: "进销存管理",
            path: "/invoicing/manage",
            isActive: false,
            icon:require("@/assets/img/menuIcons/icon-invoicingmanage.png")
          },
          {
            name: "供货商管理",
            path: "/invoicing/invoicingSet",
            isActive: false,
            icon:require("@/assets/img/menuIcons/icon-invoicinginvoicingSet.png")
          },
          {
            name: "进货单管理",
            path: "/invoicing/goodsPurchase",
            isActive: false,
            icon:require("@/assets/img/menuIcons/icon-invoicinggoodsPurchase.png")
          },
          {
            name: "进货退货单管理",
            path: "/invoicing/goodsPurchaseReturn",
            isActive: false,
            icon:require("@/assets/img/menuIcons/icon-invoicinggoodsPurchaseReturn.png")
          },
          {
            name: "库存盘点",
            path: "/invoicing/stockCheck",
            isActive: false,
            icon:require("@/assets/img/menuIcons/icon-invoicingstockCheck.png")
          },
          {
            name: "库存查询",
            path: "/invoicing/stockInquiry",
            isActive: false,
            icon:require("@/assets/img/menuIcons/icon-invoicingstockInquiry.png")
          },
          {
            name: "调拨单",
            path: "/invoicing/goodsChange",
            isActive: false,
            icon:require("@/assets/img/menuIcons/icon-invoicinggoodsChange.png")
          },
        ];
        // let topbarList = [
        //   {
        //     name: this.$route.name,
        //     isActive: false,
        //     path: this.$route.path,
        //   },
        // ];
        topbarList.forEach((val) => {
          if (val.path == this.$route.path) {
            val.isActive = true;
          }
        });
        return topbarList;
      },
  },
}
